import React from "react";
import * as css from "./css/nav-floor";
import {observer, inject} from "mobx-react";
import menuList from "./data/menu-list";
import {useHistory} from "react-router-dom";
import useMyStores from "../../../../../../hooks/useMyStores";

function NavFloor(props) {
    const {className} = props;
    const history = useHistory();

    const {app} = useMyStores()

    function renderMenu() {
        return menuList.map((item, index) => {
            const {title, location} = item;

            const onClick = () => {
                if (location) {
                    history.push(location);
                }
            };

            return (
                <css.NavItem
                    key={index}
                    onClick={() => {
                        onClick();
                    }}
                >
                    {title}
                </css.NavItem>
            );
        });
    }

    return (
        <css.NavFloor className={className}>
            <css.Nav>{renderMenu()}</css.Nav>
            <css.CopyRight>
                <css.CopyRightText>
                    © {app.recordTime} {app.app?.domain} 版权所有
                    {app.app?.websiteName} {app.app?.platformName}
                </css.CopyRightText>
                <css.CopyRightText>
                    <div
                        className="clickable"
                        onClick={() => {
                            //工信部
                            window.open(app.recordUrl);
                        }}
                    >
                        {app.website?.recordNumber}
                    </div>
                    {
                        app.website?.policeRecordNumber &&
                        <div>
                            <img src={require('./img/公安.png')}/>
                            <span style={{
                                marginLeft: 10
                            }}>{app.website?.policeRecordNumber}</span>
                        </div>
                    }
                </css.CopyRightText>
                {
                    app.contact?.show &&
                    <css.CopyRightText>
                        持有人 {app.contact?.name}
                    </css.CopyRightText>
                }
                <div id="glx-ssl-cert" style={{
                    marginTop: "12px"
                }}/>
            </css.CopyRight>
        </css.NavFloor>
    );
}

export default observer(NavFloor);
